<template>
  <div class="overlay">
    <div class="loadingGraphic">
      <img
        src="../../assets/img/loader.gif"
        class="loadingGIF"
        alt="Loading icon"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareLoadingOverlay',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  }

  .loadingGraphic {
    position: absolute;
    width: 140px;
    height: 20px;
    top: 50%;
    left: 50%;
    margin-top: -10px;
    margin-left: -70px;
  }

  .loadingGIF {
    width: 140px;
    height: 20px;
  }

</style>
